export default "__VITE_ASSET__$OUTQ14L__"